<template>
  <v-dialog
    :value="modalVisible"
    scrollable
    :max-width="modalWidth || 640"
    :persistent="persistent"
    no-click-animation
    :content-class="customClass ? customClass : 'dialog-contents__wrapper'"
    v-if="modalVisible"
    @click:outside="hideModal"
    @click.self="hideModal"
    @keydown.esc="hideModal"
  >
    <component :is="dialogComponentName" />
  </v-dialog>
</template>

<script>
import { DIALOG_MODULE } from "@/store/types/module-types";
import Vue from "vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: `BaseDialogContents`,
  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogComponentName: null,
    };
  },
  computed: {
    ...mapState(DIALOG_MODULE, [
      "modalVisible",
      "modalComponent",
      "modalWidth",
      "customClass",
    ]),
  },
  watch: {
    modalComponent(dialogComponentName) {
      if (!dialogComponentName) return;
      Vue.component(dialogComponentName, () =>
        import(`@/components/DialogContents/${dialogComponentName}`)
      );
      this.dialogComponentName = dialogComponentName;
    },
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, [`hideModal`]),
  },
};
</script>

<style lang="scss"></style>
